export const attainments = [
    {
        name: "Insero Hackathon - 3rd Place",
        location: "VIA University College, Campus Horsens (Denmark)",
        link: "https://inserohorsens.dk/",
        date: "Oct 2016",
        description: "During this hackathon we were challenged to enhance the TADAA! electric car's user experience."
    },
    {
        name: "ToPAS Lx 2016 Hackathon - 3rd Place",
        link: "https://www.di.fct.unl.pt/topas-lx-2016/vencedores",
        date: "May 2016",
        location: "Faculdade de Ciências e Tecnologia da Universidade Nova de Lisboa, Lisbon (Portugal)",
        description: "During this programming hackathon we were challenged to solve the maximum amount of the given tasks in the C programming language."
    },
]